import axios from "axios";
import { clearAll, generateUUID, getUser, getUUID, saveUser } from "./localStorage";
import moment from "moment";
const api = process.env.REACT_APP_API;

const axiosAuth = () => {
  const loggedUser = getUser();

  return axios.create({
    headers: {
      Authorization: `Bearer ${loggedUser.accessToken}`,
    },
  });
};

export const getAllApplications = ()=>{
  return new Promise((resolve, reject) => {
    axiosAuth()
      .get(`${api}/applications?uuid=${getUUID()}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data.message);
      });
  });

}

export const setApplicationsUseAlternativeURL = ({appId, useAlternative}) => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .post(`${api}/applications/${appId}`, { useAlternative: useAlternative })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data.message);
      });
  });
};



// El cliente responde (una sola vez) al aviso de registrar su correo real.
// NO cambia su usuario: solo guarda el correo donde recibira el boton Release.
// Si personalEmail viene vacio, igual se marca el aviso como respondido.
export const confirmEmailPrompt = (personalEmail) => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .post(`${api}/confirm-email?uuid=${getUUID()}`, { personalEmail })
      .then((response) => {
        // Que no vuelva a salir el aviso en esta sesion.
        const u = getUser();
        saveUser({ ...u, emailPromptDone: true });
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response?.data?.message || "Something went wrong.");
      });
  });
};

export const getProfile = ()=>{
  return new Promise((resolve, reject) => {
    axiosAuth()
      .get(`${api}/profile?uuid=${getUUID()}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data.message);
      });
  });
}



export const logIn = ({ username, password }) => {
  const uuid = generateUUID();
  return new Promise((resolve, reject) => {
    axios
      .post(`${api}/login`, { username, password, uuid })
      .then((response) => {
        saveUser(response.data);
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data.message);
      });
  });
};

// Autoservicio: pedir que liberen los navegadores (cuando el cliente choca con el
// limite). Le llega un correo con el boton Release. Respuesta neutra a proposito.
export const requestDeviceRelease = (username) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${api}/release-devices/request`, { username })
      .then((response) => resolve(response.data.message))
      .catch((error) =>
        reject(error?.response?.data?.message || "No se pudo enviar el correo. Intenta de nuevo.")
      );
  });
};

export const logOut = () => {
  clearAll();
  return new Promise((resolve, reject) => {
    axiosAuth()
      .post(`${api}/logout`)
      .then((response) => {
        window.location.reload();
        resolve(response.data);
      })
      .catch((error) => {
        window.location.reload();
        reject(error.response.data.message);
      });
  });
  
};

export const updatePassword = (password) => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .put(`${api}/users?uuid=${getUUID()}`, { password: password })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data.message);
      });
  });
};

export const updateMyAccount = ({ personalEmail, phoneNumber }) => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .put(`${api}/users?uuid=${getUUID()}`, { personalEmail, phoneNumber })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response?.data?.message || "Could not save your account.");
      });
  });
};

export const getMyDevices = () => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .get(`${api}/my-devices?uuid=${getUUID()}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response?.data?.message || "Could not load your devices.");
      });
  });
};

export const releaseMyDevices = () => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .post(`${api}/my-devices/release?uuid=${getUUID()}`, {})
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        // Devuelve el cuerpo completo para poder leer nextReleaseAt en el 429.
        reject(error.response?.data || { message: "Could not release your devices." });
      });
  });
};

export const updateInfoToUser = (user, data) => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .put(`${api}/users/${user._id}`, { ...data })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data.message);
      });
  });
};

export const deleteSpecificUser = (user) => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .delete(`${api}/users/${user._id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data.message);
      });
  });
};

export const createUser = (info) => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .post(`${api}/users`, { ...info })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data.message);
      });
  });
};

export const getUsers = (search) => {
  let dueDate;
  let dueDateSort;
  let enabledBy;
  let enabled;
  if (typeof search.dueDate !== "undefined" && search.dueDate != null && search.dueDate !== ""){
    dueDate = search.dueDateOperator + ":" +moment(search.dueDate).format('YYYY-MM-DD');
  }
  if(typeof search.dueDateSort !== "undefined" && search.dueDateSort != null && search.dueDateSort !== 0){
    dueDateSort = search.dueDateSort;
  }
  if(typeof search.enabledBy !== "undefined" && search.enabledBy != null && search.enabledBy !== ""){
    enabledBy = search.enabledBy;
  }
  if(typeof search.enabled !== "undefined" && search.enabled != null && search.enabled !== "-1"){
    enabled = search.enabled;
  }
  console.log(dueDate);
  return new Promise((resolve, reject) => {
    axiosAuth()
      .get(`${api}/userlist`, { params: { keywords: search.keywords, dueDate: dueDate, orderDueDate: dueDateSort, enabledReason:enabledBy, enabled: enabled, createdByRole: search.createdById || "", application: search.application || "", page: search.page || 1, limit: search.limit || 20 } })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data.message);
      });
  });
};

export const getCreators = () => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .get(`${api}/creators`)
      .then((response) => { resolve(response.data); })
      .catch((error) => { reject(error.response.data.message); });
  });
};

export const clearUserUUIDs = (user) => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .delete(`${api}/uuid/${user._id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response.data.message);
      });
  });
};

// Historial de accesos
export const getLoginLogs = ({ username, result, days, createdById, country, page, limit }) => {
  const params = new URLSearchParams();
  params.append("uuid", getUUID());
  if (username) params.append("username", username);
  if (result) params.append("result", result);
  if (days) params.append("days", days);
  if (createdById) params.append("createdById", createdById);
  if (country) params.append("country", country);
  params.append("page", page || 1);
  params.append("limit", limit || 25);

  return new Promise((resolve, reject) => {
    axiosAuth()
      .get(`${api}/login-logs?${params.toString()}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response?.data?.message || error.message);
      });
  });
};

// Paises distintos que aparecen en los accesos (para el selector de pais).
export const getLogCountries = () => {
  const params = new URLSearchParams();
  params.append("uuid", getUUID());
  return new Promise((resolve, reject) => {
    axiosAuth()
      .get(`${api}/login-logs/countries?${params.toString()}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data?.message || error.message));
  });
};

// Posibles cuentas compartidas: usuarios con muchas IPs/paises distintos.
export const getSharedAccounts = ({ createdById, days, minIps } = {}) => {
  const params = new URLSearchParams();
  params.append("uuid", getUUID());
  if (createdById) params.append("createdById", createdById);
  if (days !== undefined && days !== "") params.append("days", days);
  if (minIps) params.append("minIps", minIps);

  return new Promise((resolve, reject) => {
    axiosAuth()
      .get(`${api}/login-logs/shared?${params.toString()}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data?.message || error.message));
  });
};

// Bloqueo de IP (solo Super Admin)
export const getBlockedIps = () => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .get(`${api}/blocked-ips?uuid=${getUUID()}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response?.data?.message || error.message);
      });
  });
};

export const blockIp = ({ value, reason }) => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .post(`${api}/blocked-ips`, { value, reason })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response?.data?.message || error.message);
      });
  });
};

export const unblockIp = (id) => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .delete(`${api}/blocked-ips/${id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response?.data?.message || error.message);
      });
  });
};

// Domain APIs
export const getAllDomains = () => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .get(`${api}/domains?uuid=${getUUID()}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response?.data?.message || error.message);
      });
  });
};

export const getDomainById = (id) => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .get(`${api}/domains/${id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response?.data?.message || error.message);
      });
  });
};

export const createDomain = (domainData) => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .post(`${api}/domains`, domainData)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response?.data?.message || error.message);
      });
  });
};

export const updateDomain = (id, domainData) => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .put(`${api}/domains/${id}`, domainData)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response?.data?.message || error.message);
      });
  });
};

export const deleteDomain = (id) => {
  return new Promise((resolve, reject) => {
    axiosAuth()
      .delete(`${api}/domains/${id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response?.data?.message || error.message);
      });
  });
};

export const uploadImage = (file) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('image', file);
    
    axiosAuth()
      .post(`${api}/upload-image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error.response?.data?.error || error.message);
      });
  });
};


// ---------------------------------------------------------------------------
// Bloqueo en cascada: un admin limitado y los usuarios que el creo.
// ---------------------------------------------------------------------------

/** Cuantos caerian o se levantarian, para poder avisar antes de confirmar. */
export const getCascadeCount = (userId) =>
  new Promise((resolve, reject) => {
    axiosAuth()
      .get(`${api}/users/${userId}/cascade`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data?.message || "Error"));
  });

export const blockAdminCascade = (userId) =>
  new Promise((resolve, reject) => {
    axiosAuth()
      .post(`${api}/users/${userId}/block-cascade`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data?.message || "Error"));
  });

export const unblockAdminCascade = (userId) =>
  new Promise((resolve, reject) => {
    axiosAuth()
      .post(`${api}/users/${userId}/unblock-cascade`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data?.message || "Error"));
  });

/** Resumen por administrador: usuarios, activos y altas nuevas. */
export const getAdminsSummary = () =>
  new Promise((resolve, reject) => {
    axiosAuth()
      .get(`${api}/admins/summary`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data?.message || "Error"));
  });

// ---------------------------------------------------------------------------
// Apagar una aplicacion para un admin y toda su gente.
// ---------------------------------------------------------------------------

export const getAppBlocks = (userId) =>
  new Promise((resolve, reject) => {
    axiosAuth()
      .get(`${api}/users/${userId}/app-blocks`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data?.message || "Error"));
  });

export const setAppBlock = (userId, applicationId, blocked) =>
  new Promise((resolve, reject) => {
    axiosAuth()
      .put(`${api}/users/${userId}/app-blocks`, { applicationId, blocked })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data?.message || "Error"));
  });

// ---------------------------------------------------------------------------
// Aviso de mantenimiento que ve el cliente al entrar.
// ---------------------------------------------------------------------------

export const getMantenimiento = () =>
  new Promise((resolve, reject) => {
    axiosAuth()
      .get(`${api}/maintenance`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data?.message || "Error"));
  });

export const setMantenimiento = (datos) =>
  new Promise((resolve, reject) => {
    axiosAuth()
      .put(`${api}/maintenance`, datos)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data?.message || "Error"));
  });
